/**
 * Created by rhinov15 on 28/01/2016.
 */

import { ActionState, ActionStateEnum } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { ComponentConstants, Entity, Event, Events, eventsManager, Listener, math, Room, RoomQuotation, SceneConstants, Wall, WallQuotation } from "@rhinov/savane-js";
import { WallNode } from "../../plan/EntityNodes/WallNode";

declare var cc: any;


export class QuotationState extends ActionState {

    state: number = ActionStateEnum.Quotation;
    _previousGridState: boolean = PlanManager.getInstance().scrollWindow.grid._isGridVisible;
    floorChangeListener: Listener | null = null;
    sliderListener: Listener | null = null;
    dropdownListener: Listener | null = null;
    ctrlOn: boolean = false;

    constructor() {
        super();
        
        //Hide grid
        PlanManager.getInstance().scrollWindow.grid._isGridVisible = false;

        this.floorChangeListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.lockView.bind(this));

        this.sliderListener = eventsManager.instance.addListener(Events.SLIDER_BUTTON, this.sliderButtonHandler.bind(this));
        this.dropdownListener = eventsManager.instance.addListener(Events.DROP_DOWN_BUTTON, this.dropDownButtonHandler.bind(this));
    }

    getAction(): number {
        return this.state;
    }

    lockView() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true, false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    lockViewNoOffset() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true, false);
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    _isAllSelectedEntityTypeOf(type: number): boolean {
        var selectedList = PlanManager.getInstance().selectedEntities;
        for (var i = 0; i < selectedList.length; i++) {
            if (selectedList[i].entityType !== type) {
                return false;
            }
        }
        return true;

    }
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var node;
        if (hoverEntities !== null && hoverEntities.length > 0) {
            var entity = hoverEntities[0];
            if (entity.entityType !== undefined) {
                var array = [entity];
                node = EntityManager.getInstance().getNode(entity);
                if (this.ctrlOn && this._isAllSelectedEntityTypeOf(entity.entityType!)
                    && entity.entityType === SceneConstants.EntityType.Room) {//CURRENTLY WORK FOR ROOM ONLY
                    // //node.startSelectableMode();
                    // node.setSelected(true);
                    array = array.concat(PlanManager.getInstance().selectedEntities);
                    PlanManager.getInstance().updateItemsSelected(array, false, true);
                    //Call for tulip
                    eventsManager.instance.dispatch(Events.SHOW_TULIP, {
                        TypeProperties: entity.entityType,
                        obj: PlanManager.getInstance().selectedEntities,
                        cocosData: node
                    });
                } else {
                    // if (entity.entityType === SceneConstants.EntityType.Room) {
                    //     node.startSelectableMode();
                    // }
                    PlanManager.getInstance().updateItemsSelected(array, false, true);
                }

            }
        }
        return null;
    }
    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode == cc.KEY.ctrl) {
            this.ctrlOn = true;
        }

        return null;
    }
    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        if (keyCode == cc.KEY.ctrl) {
            this.ctrlOn = false;
        }
        return null;
    }
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._startDragging(posx, posy, true);
        return null;
    }

    isDecorationState(): boolean {
        return (true);
    }

    dispose() {
        //show grid
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, this._previousGridState);
        PlanManager.getInstance().scrollWindow.grid.unlockGrid();
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.endVisualiseMode();
            }
        }
        //Detach listeners
        eventsManager.instance.removeListener(this.sliderListener!);
        eventsManager.instance.removeListener(this.dropdownListener!);
        eventsManager.instance.removeListener(this.floorChangeListener!);
    }

    sliderButtonHandler(event: Event) {
        var i, j;
        var edited_prop = event.getUserData().editedProperty;
        var value = event.getUserData().value;

        var editedItem = null;
        var editedWall;
        var planManager = PlanManager.getInstance();

        switch (edited_prop) {
            case 'wallRepairDirect':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isWallEntity()
                        ? planManager.selectedEntities[i] : null;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as WallQuotation).wallRepairDirect = !(editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as any).wallRepairDirect;
                    }
                }
                break;
            case 'wallRepairUndirect':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isWallEntity()
                        ? planManager.selectedEntities[i] : null;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as WallQuotation).wallRepairUndirect = !(editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as any).wallRepairUndirect;
                    }
                }
                break;
            case 'ceilingRepair':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] : null;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.RoomQuotation) as RoomQuotation).ceilingRepair = value;
                    }
                }

                break;
            case 'repairWalls':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] as Room : null;
                    var isRepaired = event.getUserData().value;
                    if (editedItem !== null) {
                        for (j = 0; j < editedItem.walls.length; j++) {
                            editedWall = editedItem.walls[j];
                            var wallRepair = '';
                            if (editedItem.wallOrientationInRoom(editedWall)) {
                                wallRepair = 'wallRepairUndirect';
                            } else {
                                wallRepair = 'wallRepairDirect';
                            }

                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)[wallRepair] = isRepaired;
                        }


                        for (j = 0; j < editedItem.nonRoomedWalls.length; j++) {
                            editedWall = editedItem.nonRoomedWalls[j];
                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)['wallRepairUndirect'] = isRepaired;
                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)['wallRepairDirect'] = isRepaired;
                        }
                    }
                }
                break;
            default:
                break;
        }
    }

    dropDownButtonHandler (event: Event) {
        var i, j;
        var value = parseInt(event.getUserData().value);
        var edited_prop = event.getUserData().editedProperty;

        var editedItem = null;
        var editedWall = null;
        var planManager = PlanManager.getInstance();

        switch (edited_prop) {
            case 'wallCoveringDirect':
                editedItem = planManager.selectedEntities.length === 1 && planManager.selectedEntities[0].isWallEntity()
                    ? planManager.selectedEntities[0] : null;
                if (editedItem !== null) {
                    (editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as WallQuotation).wallCoveringDirect = '' + value;
                }
                break;
            case 'wallCoveringUndirect':

                editedItem = planManager.selectedEntities.length === 1 && planManager.selectedEntities[0].isWallEntity()
                    ? planManager.selectedEntities[0] : null;
                if (editedItem !== null) {
                    (editedItem.getComponent(ComponentConstants.ComponentType.WallQuotation) as WallQuotation).wallCoveringUndirect = ''+ value;
                }
                break;
            case 'floorCovering':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] : null;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.RoomQuotation) as RoomQuotation).floorCovering = value;
                    }
                }
                break;
            case 'ceilingCovering':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] : null;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.RoomQuotation) as RoomQuotation).ceilingCovering = ''+ value;
                    }
                }
                break;
            case 'wallsCovering':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] as Room : null;
                    var covering = event.getUserData().value;
                    if (editedItem !== null) {
                        for (j = 0; j < editedItem.walls.length; j++) {
                            editedWall = editedItem.walls[j];
                            var wallCovering = '';

                            if (editedItem.wallOrientationInRoom(editedWall)) {
                                wallCovering = 'wallCoveringUndirect';
                            } else {
                                wallCovering = 'wallCoveringDirect';
                            }

                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)[wallCovering] = covering;
                        }


                        for (j = 0; j < editedItem.nonRoomedWalls.length; j++) {
                            editedWall = editedItem.nonRoomedWalls[j];
                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)['wallCoveringUndirect'] = covering;
                            (editedWall.getComponent(ComponentConstants.ComponentType.WallQuotation) as any)['wallCoveringDirect'] = covering;
                        }
                    }
                }

                break;
            case 'kitchenSize':
                for (i = 0; i < planManager.selectedEntities.length; i++) {
                    editedItem = planManager.selectedEntities[i].isRoomEntity() ? planManager.selectedEntities[i] : null;
                    var size = event.getUserData().value;
                    if (editedItem !== null) {
                        (editedItem.getComponent(ComponentConstants.ComponentType.RoomQuotation) as RoomQuotation).kitchenSize = size;
                    }
                }
                break;
            default:
                break;
        }
    }
    snapClick (): ActionState | null {
        return null;
    }
}
